module.exports = __webpack_public_path__ + "static/nine_lives_stealer-951632cc6246dd07c116ffb16cc40bf6.jpeg";